module.exports = __webpack_public_path__ + "img/QR_Code.ebf20c46.jpg";